<template>
  <div style="background-color:#1a181c;">
    <div class="container pt-40 color-fff">
      <b-row>
        <b-col lg="3">
          <div class="block mb-40">
            <div class="b-title pl-20 fs-20 bold mb-20">主办机构</div>
            <a
              v-for="(v, i) in list1"
              :key="i"
              class="pl-20 fs-16 mb-20 link"
              :href="v.url"
              target="_blank"
              >{{ v.name }}
            </a>
          </div>
          <div class="block mb-40">
            <div class="b-title pl-20 fs-20 bold mb-20">执行机构</div>
            <a class="pl-20 fs-16 mb-20 link" href="#" target="_blank"
              >广州展联展览服务有限公司
            </a>
          </div>
        </b-col>
        <b-col lg="3">
          <div class="block mb-40">
            <div class="b-title pl-20 fs-20 bold mb-20">承办机构</div>
            <a
              v-for="(v, i) in list2"
              :key="i"
              class="pl-20 fs-16 mb-20 link"
              :href="v.url"
              target="_blank"
              >{{ v.name }}
            </a>
          </div>
        </b-col>
        <b-col lg="3">
          <div class="block mb-40">
            <div class="b-title pl-20 fs-20 bold mb-20"></div>
            <a
              v-for="(v, i) in list3"
              :key="i"
              class="pl-20 fs-16 mb-20 link"
              :href="v.url"
              target="_blank"
              >{{ v.name }}
            </a>
          </div>
        </b-col>
        <b-col lg="3">
          <b-row v-for="item in imgList" :key="item">
            <b-col>
              <img class="logo_img mb-20" :src="item" />
            </b-col>
          </b-row>
        </b-col>
      </b-row>
      <footer class="fs-20 pt-30 pb-30">
        <div class="nav mb-bottom">
          <a v-for="(v, i) in nav" :key="i" @click="toFriend(v.url)"
            >{{ v.name }}
            <span class="ml-20 mr-20" v-if="i < 3">|</span>
          </a>
        </div>
        <div class="copyright  clearfix">
          <div style="color:#999;">
            广州展联展览服务有限公司版权所有
          </div>
          <a target="_blank" href="https://beian.miit.gov.cn/"
            >&nbsp;粤ICP备17092841号-4</a
          >
        </div>
      </footer>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      list1: [
        { name: "中国对外贸易中心", url: "https://www.bilibili.com/" },
        { name: "中国机械工业联合会", url: "https://www.bilibili.com/" },
        { name: "中国汽车工业协会", url: "https://www.bilibili.com/" },
        {
          name: "中国国际贸易促进委员会汽车行业分会",
          url: "https://www.bilibili.com/",
        },
      ],
      list2: [
        {
          name: "中国对外贸易广州展览有限公司",
          url: "https://www.bilibili.com/",
        },
        { name: "广州汽车工业集团有限公司", url: "https://www.bilibili.com/" },
        { name: "中国汽车工业学会", url: "https://www.bilibili.com/" },
        { name: "广州联合展贸有限公司", url: "https://www.bilibili.com/" },
      ],
      list3: [
        {
          name: "中国国际贸易促进委员会广州市分会",
          url: "https://www.bilibili.com/",
        },
        { name: " 广州市汽车服务业协会", url: "https://www.bilibili.com/" },
        { name: "广州工业经济联合会", url: "https://www.bilibili.com/" },
        {
          name: "中国国际贸易促进委员会汽车行业分会",
          url: "https://www.bilibili.com/",
        },
      ],
      imgList: [
        require("../assets/img/logo_1.png"),
        require("../assets/img/logo_2.png"),
        require("../assets/img/logo_3.png"),
      ],
      nav: [
        {
          name: "联系我们",
          url: "/friendlyLink?tab=3",
        },
        {
          name: "友情链接",
          url: "/friendlyLink?tab=2",
        },
        {
          name: "法律声明",
          url: "/friendlyLink?tab=1",
        },
        {
          name: "网站地图",
          url: "/friendlyLink?tab=0",
        },
      ],
    };
  },
  methods: {
    toFriend(url) {
      this.$router.push({ path: url });
    },
  },
};
</script>

<style lang="scss" scoped>
.page-footer {
  border-top: 2px solid;
  background-color: #1a181c;
}

a {
  position: relative;
  display: block;
  color: #999999;
  cursor: pointer;
}
.copyright {
  display: flex;
  justify-content: center;
  align-items: center;
}
.nav {
  display: flex;
  justify-content: center;
  align-items: center;
}
@media screen and (min-width: 100px) and (max-width: 1000px) {
  .mb-bottom {
    margin-bottom: 90px;
  }
  footer {
    text-align: center;
    flex-direction: column;
    border-top: 2px solid #999;
  }
  .logo_img {
    width: 300px;
  }
  .link {
    &::after {
      content: "·";
      position: absolute;
      left: 0;
      top: 50%;
      transform: translateY(-50%);
      color: #999999;
      font-size: 60px;
    }
  }
  .b-title {
    position: relative;
    &::after {
      position: absolute;
      left: 0;
      top: 40%;
      transform: translateY(-40%);
      content: "";
      width: 12px;
      height: 80%;
      background: #fff;
      border-radius: 5px;
    }
  }
}
@media screen and (min-width: 1000px) and (max-width: 2560px) {
  footer {
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-top: 1px solid #999;
  }
  .logo_img {
    width: 140px;
    height: 65px;
  }
  .link {
    &::after {
      content: "·";
      position: absolute;
      left: 0;
      top: 50%;
      transform: translateY(-50%);
      color: #999999;
      font-size: 20px;
    }
  }
  .b-title {
    position: relative;
    &::after {
      position: absolute;
      left: 0;
      top: 40%;
      transform: translateY(-40%);
      content: "";
      width: 6px;
      height: 80%;
      background: #fff;
      border-radius: 5px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// pageBottom.vue?81f85a10